export const seasons: TableModule = {
    name: "seasons",
    route: "spa.basicData.seasons",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "sport_name",
            mobile: true,
        }, {
            name: "date",
        }, {
            name: "status",
            width: 'w-[220px]',
        }
    ],
    filters: [
        {
            name: "sport",
            column: "sport_id",
            type: "select",
            reduced: 'in',
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.basicData.sportSelect.index')
            ).then(response => response.data?.map(
                (sport: { id: number, name: string }) => ({
                    value: sport.id,
                    label: sport.name
                }))
            ),
            ability: ['viewAny', 'sports']
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "seasons"]
        }
    ]
}